"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useArrayOperator;

var _Editor = require("./Editor");
/* global __DEV__ */


function useArrayOperator() {
  var _useEditor = (0, _Editor.useEditor)(),
      dispatch = _useEditor.dispatch,
      getState = _useEditor.getState;

  if (__DEV__) {
    if (!Array.isArray(getState())) {
      throw new Error('Trying to use an array operator without an array value');
    }
  }

  return {
    remove: function remove(idx) {
      return dispatch(idx, undefined, _Editor.OP_ARRAY_REMOVE);
    },
    insert: function insert(idx, value) {
      return dispatch(idx, value, _Editor.OP_ARRAY_INSERT);
    }
  };
}